import Navbar from "@/components/Navbar";
import MallangCanvas from "./components/MallangCanvas";

/** 말랑이: a squishy toy to press, pinch and knead (it never breaks). */
export default function Mallang() {
  return (
    <main className="relative w-full h-dvh overflow-hidden">
      <Navbar />
      <MallangCanvas />
    </main>
  );
}
